// src/frontend_react/src/components/ui/Checkbox/Checkbox.js
import React from 'react';
import styles from './Checkbox.module.css';

const Checkbox = ({
  id,
  label,
  name,
  checked,
  onChange, 
  disabled = false,
  required = false, 
  error, 

  hintText,
  className = '', 
  labelClassName = '',
  inputClassName = '',
  style,
  alignSelf,
  flexGrow,
  ...rest
}) => {
  const checkboxId = id || name || `checkbox-${Math.random().toString(36).substring(2, 9)}`;
  const mainLabel = typeof label === 'string' ? label : null;
  const customLabelElement = typeof label !== 'string' ? label : null;

  const wrapperStyle = { ...style };
  if (alignSelf) wrapperStyle.alignSelf = alignSelf;
  if (flexGrow) wrapperStyle.flexGrow = flexGrow;

  return (
    <div
      className={`${styles.checkboxWrapper} ${disabled ? styles.disabled : ''} ${error ? styles.errorState : ''} ${className}`}
      style={wrapperStyle}
    >
      <input
        type="checkbox"
        id={checkboxId}
        name={name}
        checked={!!checked} 
        onChange={onChange}
        disabled={disabled}
        required={required}
        className={`${styles.input} ${inputClassName}`}
        aria-invalid={!!error}
        aria-describedby={hintText || (typeof error === 'string' && error) ? `${checkboxId}-description` : undefined}
        {...rest}
      />
      <label htmlFor={checkboxId} className={`${styles.label} ${labelClassName}`}>
        {mainLabel && <span className={styles.labelTextContent}>{mainLabel}</span>}
        {customLabelElement}
        {required && !mainLabel && !customLabelElement && <span className={styles.requiredIndicator}>* (Required)</span>}
      </label>
      {(hintText || (typeof error === 'string' && error)) && (
        <div id={`${checkboxId}-description`} className={styles.descriptionArea}>
            {typeof error === 'string' && error && <p className={styles.errorMessageText}>{error}</p>}
            {!error && hintText && <p className={styles.hintText}>{hintText}</p>}
        </div>
      )}
    </div>
  );
};

export default Checkbox;